import SerializerWidget from './SerializerWidget'
import RichTextWidget from './RichTextWidget'
import ImageWidget from './ImageWidget'
import YoutubeWidget from './YoutubeWidget'
import LodestoneClassJobWidget from './LodestoneClassJobWidget'
import LodestonePortraitWidget from './LodestonePortraitWidget'

export {
  SerializerWidget,
  RichTextWidget,
  ImageWidget,
  YoutubeWidget,
  LodestoneClassJobWidget,
}

export default {
  Serializer: SerializerWidget,
  RichText: RichTextWidget,
  Image: ImageWidget,
  Youtube: YoutubeWidget,
  LodestoneClassJob: LodestoneClassJobWidget,
  LodestonePortrait: LodestonePortraitWidget,
}
